module.exports = __webpack_public_path__ + "static/media/icon_erro_og01.875432ea.svg";